import React from "react";
import SecondaryButton from "../Button/SecondaryButton";

interface CartSubscribeSectionProps {
  handleSubmit: (e: React.MouseEvent) => void;
}

const CartSubscribeSection: React.FC<CartSubscribeSectionProps> = ({
  handleSubmit,
}) => {
  return (
    <div>
      <section className="flex gap-2 p-2  flex-col md:flex-row py-5">
        <form className="w-full">
          <section className="flex md:flex-row flex-col gap-4 ">
            <SecondaryButton onClick={handleSubmit} label={"Add to Cart"} />

            {/* <RetailerModal /> */}
          </section>
        </form>
      </section>

      {/* <p
        className="mt-5 flex items-center text-sm box-border text-[#212529] text-sm font-normal h-[21px]
       leading-normal text-left w-auto mr-2 ">
        Estimated arrival time is 3 business days
      </p> */}
    </div>
  );
};

export default CartSubscribeSection;
